import styled, { css } from 'styled-components';
export const Container = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};

  background: linear-gradient(var(--bg-pro-gradient-start), var(--bg-pro-gradient-end));
  background: radial-gradient(
    135.71% 135.71% at 28.85% 0%,
    var(--bg-pro-gradient-start) 0%,
    var(--bg-pro-gradient-end) 100%
  );

  border-radius: var(--radius-brand);
  white-space: nowrap;
  font-weight: var(--font-weight-medium);
  font-family: inherit;
  color: var(--text-on-brand);

  appearance: none !important; // NOTE: Required for Safari.

  ${({ size }) => size === 'large' &&
    css `
      padding: 0 var(--space-600);
      height: var(--space-1400);
      font-size: var(--font-size-400);
      line-height: var(--font-line-height-400);
    `}

  ${({ size }) => size === 'medium' &&
    css `
      padding: 0 var(--space-500);
      height: var(--space-1200);
      font-size: var(--font-size-400);
      line-height: var(--font-line-height-400);
    `}

  ${({ size }) => size === 'small' &&
    css `
      padding: 0 var(--space-400);
      height: var(--space-1000);
      font-size: var(--font-size-400);
      line-height: var(--font-line-height-400);
    `}

  ${({ size }) => size === 'micro' &&
    css `
      padding: 0 var(--space-250);
      height: var(--space-800);
      font-size: var(--font-size-300);
      line-height: var(--font-line-height-300);
    `}

  &:hover:not(:disabled) {
    background: linear-gradient(
      var(--bg-pro-gradient-start-hover),
      var(--bg-pro-gradient-end-hover)
    );
    background: radial-gradient(
      135.71% 135.71% at 28.85% 0%,
      var(--bg-pro-gradient-start-hover) 0%,
      var(--bg-pro-gradient-end-hover) 100%
    );
  }

  &:active:not(:disabled),
  &:focus:not(:disabled) {
    background: linear-gradient(
      var(--bg-pro-gradient-start-hover),
      var(--bg-pro-gradient-end-hover)
    );
    background: radial-gradient(
      135.71% 135.71% at 28.85% 0%,
      var(--bg-pro-gradient-start-hover) 0%,
      var(--bg-pro-gradient-end-hover) 100%
    );
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;
